import React, { useState, useEffect } from "react";
import styles from "./styles.module.css";
import Modal from "../modal";
import { MdClose } from "react-icons/md";
import PropInput from "./propInput";

export default function EditOpperation({
  opperation,
  onSave,
  onClose,
  actions,
  sources,
}) {
  const [schema, setSchema] = useState(null);
  const [_opperation, setOpperation] = useState(null);

  useEffect(() => {
    if (opperation) {
      setOpperation(opperation);
      console.log(opperation);
      const _schema = actions.find((x) => x.displayName === opperation.name);
      setSchema(_schema);
    } else {
      setSchema(null);
      setOpperation(null);
    }
  }, [opperation]);

  const handleChange = (child, i) => {
    const opperataion = { ..._opperation };
    opperataion.children[i] = child;
    setOpperation(opperataion);
  };
  if (!_opperation || !schema) {
    return null;
  }
  return (
    <Modal onClose={onClose} open={true}>
      <div className={styles.editAction}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className={styles.title}>{_opperation.name}</div>
          <MdClose onClick={onClose} className={styles.close} />
        </div>
        {_opperation.children.map((child, index) => {
          return (
            <ChildEditor
              key={child.id}
              sources={sources}
              schema={schema}
              child={child}
              onChange={(child) => handleChange(child, index)}
            />
          );
        })}

        <button onClick={() => onSave(_opperation)} className={styles.save}>
          SAVE
        </button>
      </div>
    </Modal>
  );
}

const ChildEditor = ({ child, schema, sources, onChange }) => {
  const [childSchema, setChildSchema] = useState(null);

  useEffect(() => {
    const childSchema = schema.children.find((x) => x.name === child.name);
    setChildSchema(childSchema);
  }, [child, schema]);

  if (!childSchema) {
    return null;
  }

  if (childSchema.props.length === 0) {
    return null;
  }
  return (
    <div>
      <div className={styles.editChildTitle}>{child.displayName}</div>
      {childSchema.props.map((p) => {
        return (
          <PropInput
            onChange={onChange}
            action={child}
            prop={p}
            key={p.name}
            sources={sources}
          />
        );
      })}
    </div>
  );
};
